/**
 * Where purchase-web keeps its last good feature-flag reads (UAT-BLOCKERS D1 item 11, owner ruling "Remember the last
 * good read"): the app's ONE `StorageService`, one record per AUDIENCE — the admin app's and the public tenant site's
 * reads share an origin, so each names its own key. A LEAF — it imports nothing from the app — because both the flags
 * readers (`flagsApi.js`) and the admin auth storage (which clears the admin read on sign-out) read it.
 *
 * @module core/featureFlags/flagLastReadStore
 */

import { createFlagLastReadStore } from '@puffin-core/feature-flags/react-http';
import { StorageService } from '@puffin-core/storage';

/** The admin app's last good read; cleared when an admin session ends. */
export const adminFlagLastReadStore = createFlagLastReadStore({
  storage: StorageService.getInstance(),
});

/** The tenant site's last good read (its audience declares no flag yet, so a saved read keeps no key). */
export const storefrontFlagLastReadStore = createFlagLastReadStore({
  storage: StorageService.getInstance(),
  key: 'lastRead.storefront',
});
